import React from 'react';
import { Link } from 'react-router-dom';

export function VenueOwnerCTA() {
  return (
    <section data-testid="venue-owner-cta-section">
      <div className="flex flex-col items-center justify-between gap-5 rounded-3xl bg-gradient-to-l from-[#161006] to-[#3a2410] p-8 text-center sm:flex-row sm:text-right">
        <div>
          <h3 className="text-xl font-black text-white sm:text-2xl">هل أنت صاحب ملعب؟</h3>
          <p className="mt-1 text-sm text-white/70">انضم إلى تسيار للملاعب — لوحة مستقلة لإدارة حجوزاتك وكورتاتك، وابدأ العرض في السوق العام بعد الاعتماد</p>
        </div>
        <Link
          to="/venue-owner/register"
          data-testid="venue-owner-cta-register-link"
          className="shrink-0 rounded-full bg-orange-500 px-7 py-3 text-sm font-bold text-white transition-transform hover:-translate-y-0.5 hover:bg-orange-400"
        >
          انضم إلى تسيار للملاعب
        </Link>
      </div>
    </section>
  );
}
